import React, { useState } from 'react'
import { compose } from 'recompose'
// import Script from 'react-load-script'
import { Button, message } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import { graphql } from 'react-apollo'
import _get from 'lodash/get'
import payRegistrationMutation from '~/App/graphql/mutations/payRegistration.gql'
import { Block } from '../styles'
// import { inject, observer } from 'mobx-react'
const Linepay = compose(
  injectIntl,
  // withRouter,
  graphql(payRegistrationMutation, {
    name: 'payRegistration'
  })
)(({ intl, registration, payRegistration, discounted, gatewayRate, gatewaySettings, systemFee, totalSystemFee, itemsDiscounted }) => {
  const totalAmount = discounted + itemsDiscounted
  const fee = Math.round(gatewayRate * discounted * 100) / 100
  const finalAmount = totalAmount + fee
  const [paymentLoading, setPaymentLoading] = useState(false)

  const handleCheckout = async () => {
    // e.preventDefault()
    setPaymentLoading(true)
    try {
      const { data } = await payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method: 'linepay',
            data: {
              linepay: {
                completeRedirect: `${process.env
                  .REACT_APP_BASE_URI}/reg/${registration._id}`
                // confirmUrl: `${config('baseUri')}/linepayconfirm`,
                // cancelUrl: `${config('baseUri')}/linepaycancel`
              }
            }
          }
        }
      })
      const paymentUrl = _get(
        data,
        'payRegistration.record.data.linepay.paymentUrl.web'
      )
      if (paymentUrl) {
        window.location.href = paymentUrl
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      setPaymentLoading(false)
    }
  }

  return <Block>
    <div className="title">
      <FormattedMessage id="paymentMethod.linepay" />
    </div>
    <div>
      {systemFee
        ? <React.Fragment>
          <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(discounted - totalSystemFee)
          }} />
          <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(totalSystemFee)
          }} />
        </React.Fragment>
        : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
          amount: intl.formatNumber(discounted)
        }} />
      }
      <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
        amount: intl.formatNumber(fee)
      }} />
      {itemsDiscounted > 0 && <FormattedMessage id="app.itemsAmountBaht" defaultMessage="Extra Products {amount} Baht" tagName="div" values={{
        amount: intl.formatNumber(itemsDiscounted)
      }} />}
    </div>
    <Button
      type="primary"
      onClick={() => handleCheckout()}
      loading={paymentLoading}
      className="paymentButton"
    >
      <FormattedMessage id="app.payBaht" values={{
        amount: intl.formatNumber(finalAmount)
      }} />
    </Button>
  </Block>
})

export default Linepay



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/Linepay/Linepay.js